<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-04 15:24:02
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-18 11:53:35
-->
<template>
  <el-dialog :visible.sync="showDetail" width="900px" @closed="$emit('closed')" :append-to-body="true">
    <!-- <div slot="title" style="padding-bottom: 25px;position: relative;">
      {{ message.title }}
      <br />
      <span style="color:#7f7fa8;position: absolute;bottom: 0;font-size: 12px;">{{ message.pubtime }}</span>
    </div>
    <div style="line-height:1.8">
      {{ message.content }}
    </div> -->
    <div slot="title">系统公告</div>
    <div class="container">
      <img :src="url" class="image" />
      <div>
        <p class="title">{{ message.header }}</p>
        <p class="time">{{ moment(message.pushTime).format('YYYY-MM-DD HH:mm:ss') }}</p>
        <div class="content">
          <!-- {{ message.content }} -->
          <div v-for="(item, index) in message.message ? message.message.split('\n') : []" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="showDetail = false">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDetail: false,
      url: require('@/assets/images/noticeDialog.png'),
    }
  },
  methods: {
    moment,
  },
  watch: {
    showDetail(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.showDetail = val
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  padding: 30px 50px;
  display: flex;
  .image {
    width: 222px;
    height: 210px;
    margin-right: 64px;
  }
  .title {
    font-weight: bold;
    color: #010517;
    font-size: 16px;
  }
  .time {
    color: #999999;
    font-size: 12px;
    margin-top: 16px;
    margin-bottom: 40px;
  }
  .content {
    line-height: 30px;
    font-weight: 400;
    color: #666666;
    font-size: 14px;
  }
}
</style>
